<template>
  <div class="form-single-selec">
    <ul class="from-single-select-list">
      <li
        class="from-single-select-option"
        v-for="option of options"
        :key="option.value"
      >
        <ion-button
          :fill="option.value === choice ? 'solid' : 'outline'"
          :class="{ next: option.next }"
          @click="onClick($event, option)"
          expand="block"
          >{{ option.label }}</ion-button
        >
      </li>
    </ul>
    <transition name="slide-in">
      <div class="form-section" v-if="isExtraRequired">
        <div class="form-notes">
          <ion-button @click="openNotesModal" fill="clear">
            <ion-icon slot="start" name="text" />
            <span>Add notes</span>
          </ion-button>
          <div class="extra-content" @click="openNotesModal">
            <span>{{ notes }}</span>
          </div>
        </div>
        <div class="form-photos">
          <ion-button @click="openPhotosModal" fill="clear">
            <ion-icon slot="start" name="camera"></ion-icon>
            <span>Add photos</span>
          </ion-button>
          <div class="extra-content" @click="openPhotosModal">
            <photos-gallery :files="photos" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PhotosModal from "../PhotosModal.vue";
import NotesModal from "../NotesModal.vue";
import PhotosGallery from "../PhotosGallery.vue";

export default {
  name: "FormSelectSingle",
  components: {
    PhotosGallery
  },
  props: {
    value: Object,
    properties: Object
  },
  computed: {
    isExtraRequired() {
      if (this.choice) {
        const option = this.options.find(
          option => option.value === this.choice
        );
        if (option && option.next) {
          return false;
        }
        return true;
      }
      return false;
    },
    options() {
      return this.properties.options;
    },
    choice: {
      get() {
        return (this.value || {}).choice;
      },
      set(value) {
        this.$emit("input", { ...this.value, choice: value });
      }
    },
    photos: {
      get() {
        return (this.value || {}).photos;
      },
      set(value) {
        this.$emit("input", { ...this.value, photos: value });
      }
    },
    notes: {
      get() {
        return (this.value || {}).notes;
      },
      set(value) {
        this.$emit("input", { ...this.value, notes: value });
      }
    }
  },
  methods: {
    onClick(e, option) {
      this.choice = option.value;
      this.$nextTick(() => {
        const button = e.target;
        if (button) {
          button.classList.add("blinking");
          setTimeout(() => {
            button.classList.remove("blinking");
            if (button.classList.contains("next")) {
              setTimeout(() => {
                this.$emit("next");
              }, 200);
            }
          }, 600);
        }
      });
    },
    openPhotosModal() {
      const onPhotos = function(value) {
        this.photos = value;
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: PhotosModal,
          componentProps: {
            propsData: {
              data: this.photos,
              onPhotos
            }
          }
        })
        .then(modal => modal.present());
    },
    openNotesModal() {
      const onNotes = function(value) {
        this.notes = value;
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: NotesModal,
          componentProps: {
            propsData: {
              data: this.notes,
              onNotes
            }
          }
        })
        .then(modal => modal.present());
    }
  }
};
</script>

<style lang="scss" scoped>
.from-single-select {
  &-list {
    text-align: left;
    margin: 0;
    padding: 0;
  }
  &-option {
    list-style: none;
    min-width: 100px;
    width: fit-content;
  }
}

.extra-content {
  margin-left: 42px;
}

.blinking {
  animation: blinker 0.3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.slide-in-enter-active {
  animation: slide-in 0.5s, fade-in 0.5s;
}

@keyframes slide-in {
  from {
    transform: translateX(-100px);
  }
  to {
    transform: translateX(-0px);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
